<template>
    <div @click.stop="">
        <div class="route-map-container">
            <route-creation-map :draggable="true" :show-make-new-traffic-control-button="true"
                @close="createRoute = false" @on-geometry="onGeometry" />
        </div>
        <div v-if="!contract" class="row px-3">
            <div class="col-sm-6">
                <span class="span-title">{{ $t('contracts.ely_contracts') }}</span>
                <open-contract-filter
                    ref="elyContractFilter"
                    :to="toTime"
                    :from="fromTime"
                    :show-company="false"
                    :show-title="false"
                    :only-ely="true"
                    @loading="loading++"
                    @loading-completed="loading--"
                    @contract-selected="setElyContract"
                />
            </div>
        </div>
        <div class="row px-3">
            <div class="col-sm-6">
                    <span class="search-title">
                        {{ $t('delivery_note.date') }} - {{ $t('trip_list.road_sec_from') }}
                    </span>
                    <date-time-picker
                        class="routa-input"
                        v-model:date="fromTime"
                        format="dd.MM.yyyy HH:mm"
                        :enableTimePicker="true"
                        :placeholder="$t('observations_videos.search_input_format')"
                    />
                </div>
                <div class="col-sm-6">
                    <span class="search-title">
                        {{ $t('delivery_note.date') }} - {{ $t('trip_list.road_sec_to') }}</span>
                    <date-time-picker
                        class="routa-input"
                        v-model:date="toTime"
                        format="dd.MM.yyyy HH:mm"
                        :enableTimePicker="true"
                        :placeholder="$t('observations_videos.search_input_format')"
                    />
                </div>
        </div>
        <div class="row px-3">
            <div class="col-sm-6">
                <contract-order-multiselect
                    ref="orderFilter"
                    :contract-ids="contractOptions"
                    :single-mode="true"
                    @orders-selected="setOrder"
                />
            </div>
            <div class="col-sm-6">
                <span class="span-title">
                    {{ $t('vehicle_editor.registration_number') }}
                </span>
                <input
                    id="license_plate"
                    v-model="licensePlate"
                    type="text"
                    class="form-control form-control-sm"
                />
            </div>
        </div>
        <div v-for="(item, index) in materialReports" :key="index">
            <div class="row px-3">
                <div class="col-10">
                    <div class="row">
                        <span class="span-title">
                            {{ $t('spreader_data.dry_material') }}
                        </span>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <span class="search-title ">{{ $t('spreader_data.materials') }}</span>
                            <spreader-material-selector :materialType="materialTypes.DRY"
                                @onMaterialSelection="value => item.materialReportDryMaterial = value ? value.material : value" />
                        </div>
                        <div class="col-3">
                            <span class="search-title ">{{ $t('spreader_data.amountWithoutUnit') }}</span>
                            <input
                                id="amount"
                                v-model="item.materialReportDryAmount"
                                type="number"
                                step="any"
                                class="form-control form-control-sm no-margin"
                            />
                        </div>
                        <div class="col-3">
                            <span class="search-title ">{{ $t('spreader_data.unit') }}</span>
                            <select
                                id="unit"
                                v-model="item.materialReportDryUnit"
                                class="form-select form-select-sm no-margin"
                            >
                                <option
                                    v-for="option in routaMaterialUnitOptions"
                                    :key="option.value"
                                    :value="option.value"
                                >
                                    {{ option.text }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-1">
                        <span class="span-title">
                            {{ $t('spreader_data.liquid_material') }}
                        </span>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <span class="search-title ">{{ $t('spreader_data.materials') }}</span>
                            <spreader-material-selector :materialType="materialTypes.LIQUID"
                                @onMaterialSelection="value => item.materialReportLiquidMaterial = value ? value.material : value" />
                        </div>
                        <div class="col-3">
                            <span class="search-title ">{{ $t('spreader_data.amountWithoutUnit') }}</span>
                            <input
                                id="amount"
                                v-model="item.materialReportLiquidAmount"
                                type="number"
                                step="any"
                                class="form-control form-control-sm no-margin"
                            />

                        </div>
                        <div class="col-3">
                            <span class="search-title ">{{ $t('spreader_data.unit') }}</span>
                            <select
                                id="unit"
                                v-model="item.materialReportLiquidUnit"
                                class="form-select form-select-sm no-margin"
                            >
                                <option v-for="option in routaMaterialUnitOptions" :key="option.value" :value="option.value">
                                    {{ option.text }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-2 mt-auto">
                    <button class="btn btn-sm btn-danger m-1" :disabled="materialReports.length <= 1" @click.stop="removeMaterialReport(index)">
                        <i class="fa fa-trash" style="font-size: .8em; padding: 0; line-height: 1em;" />
                    </button>
                    <button class="btn btn-sm btn-success m-1" @click.stop="addMaterialReport">
                        <i class="fa fa-plus" style="font-size: .8em; padding: 0; line-height: 1em;" />
                    </button>
                </div>
            </div>
            <div class="row divider" v-if="index < (materialReports.length - 1)">
                <hr />
            </div>
        </div>
        <div v-if="loading" id="loader" class="spinner" />
        <hr class="mx-2"/>
        <div class="d-flex justify-content-end px-3 pb-3">
            <button class="btn btn-secondary form-button" @click.stop.prevent="emitClose">
                {{ $t('common.close') }}
            </button>
            <button class="btn btn-success form-button" :disabled="!hasValidForm"
                @click.stop.prevent="sendMaterialReport">
                {{ $t('common.add') }}
            </button>
        </div>
    </div>
</template>

<script>
import RouteCreationMap from "@/components/map/RouteCreationMap"
import SpreaderMaterialSelector from "@/components/materials/spreaderdata/SpreaderMaterialSelector.vue";
import { spreaderDataMixin } from "@/components/mixins/SpreaderDataMixin";
import {timeUtils} from '@/components/mixins/TimeUtils'
import { restApi } from '@/components/mixins/RestApiMixin'
import MaterialReportModel from "@/models/integrations/harja/MaterialReportModel";
import DateTimePicker from "@/components/common/DateTimePicker";
import {inject} from "vue";
import ContractOrderMultiselect from "../order/ContractOrderMultiselect.vue";

export default {
    name: 'RouteMaterialCreator',
    components: {ContractOrderMultiselect, RouteCreationMap, SpreaderMaterialSelector, DateTimePicker },
    mixins: [restApi, spreaderDataMixin, timeUtils],
    props: {
        contract: {
            type: Object,
            default: null
        },
    },
    computed: {
        routaMaterialUnitOptions() {
            return this.supportedRoutaUnits()
        },
        hasValidForm() {
            return this.hasValidMaterials && this.hasValidRoute && !!this.order && !!this.licensePlate && !!this.selectedContract
        },
        hasValidMaterials() {
            if (this.materialReports.length === 0) {
                return false
            }

            return this.materialReports.every(item => !!(item.materialReportDryMaterial || item.materialReportLiquidMaterial) && !!(item.materialReportDryUnit || item.materialReportLiquidUnit))
        },
        hasValidRoute() {
            return !!this.roadGeometry
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            roadGeometry: null,
            licensePlate: null,
            order: null,
            fromTime: null,
            toTime: null,
            materialReports: [],
            selectedContract: null,
            contractOptions: []
        }
    },
    watch: {
        selectedContract() {
            this.contractOptions = this.selectedContract ? [this.selectedContract.id] : []
        }
    },
    mounted() {
        this.fromTime = this.getMonthStart()
        this.toTime = this.timestampToISOString(new Date().getTime())
        this.selectedContract = this.contract
        this.addMaterialReport()
    },
    methods: {
        setOrder(order) {
            this.order = order
        },

        setElyContract(contract) {
            this.selectedContract = contract
        },
        onGeometry(geometry) {
            this.roadGeometry = geometry
        },
        addMaterialReport() {
            const material = new MaterialReportModel(null, 0, null, null, 0, null)
            this.materialReports.push(material)
        },
        removeMaterialReport(index) {
            this.materialReports.splice(index, 1)
        },
        emitClose() {
            this.$emit('close')
        },
        sendMaterialReport() {
            if (!this.roadGeometry) {
                this.showAlert(this.$t('spreader_data.alert_materials_add_route_missing'), 'warning')
                return
            }
            const payload = {
                trip: {
                    geometry: this.roadGeometry.map(point => ({ x: Number(point.lon), y: Number(point.lat) })),
                    license_plate: this.licensePlate,
                    order_id: this.order ? this.order.id : null,
                    contract_id: this.selectedContract.id,
                    start_time: this.fromTime,
                    end_time: this.toTime
                },
                materialReports: this.materialReports.map(report => report.toJSON())
            }

            this.loading = true
            this.restAdd(this.spreaderDataAddToRoutaUrl, payload, (response) => {
                this.loading = false
                // If status is 206, it means that some of the materials are not sent to Harja successfully
                if(response.status === 206) {
                    this.showAlert(this.$t('spreader_data.alert_materials_add_partial_success'), 'warning')
                } else {
                    this.showAlert(this.$t('spreader_data.alert_materials_add_success'), 'success')
                }

                this.emitClose()
            }, () => {
                this.loading = false
                this.showAlert(this.$t('spreader_data.alert_materials_add_fail'))
            })
        }
    }
}
</script>
<style scoped>
.route-map-container {
    position: relative;
    height: 60vh;
}

.divider>div {
    width: 95%;
}

.route-map-container :deep(#routa-material-route-map) {
    height: 70vh !important;
}

.actions {
    justify-content: end;
    display: flex;
}
</style>
